module.exports = __webpack_public_path__ + "img/elburg-4.2498fc14.jpg";